import breakpoints from '@carvana/merch-tailwind/breakpoints';
import { memo } from 'react';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useImageWithFallback from '~/hooks/common/ui/useImageWithFallback';
import optimizeImage, { Options } from '~/utilities/optimizeImage';
import useGetHeroImages, { ImageType } from './useGetHeroImages';

const OPTIMIZATION_CONFIG: Options = {
  format: 'auto',
  optimize: 'high',
  quality: 90
};

function VehicleImage() {
  const { year, make, model } = useGetVehicleDetails();
  const { heroImageMap, initialImageType } = useGetHeroImages();
  const loadedImage = useImageWithFallback<ImageType>(
    heroImageMap,
    initialImageType,
    'hero'
  );

  const image = loadedImage || heroImageMap[initialImageType];

  const isStockImage =
    image?.imageType === ImageType.JellyBean ||
    image?.imageType === ImageType.Generic;

  return image?.url ? (
    <div className="pointer-events-none absolute inset-0 z-2">
      <picture>
        <source
          media={`(min-width: ${breakpoints.sm}px)`}
          srcSet={optimizeImage(image.url, {
            ...OPTIMIZATION_CONFIG,
            width: breakpoints.md
          })}
        />
        <img
          alt={`${year} ${make} ${model} vehicle photo`}
          className={image.classes}
          decoding="async"
          draggable="false"
          loading="eager"
          src={optimizeImage(image.url, {
            ...OPTIMIZATION_CONFIG,
            width: breakpoints.sm
          })}
        />
      </picture>
      {isStockImage && (
        <div className="absolute bottom-2xl left-2xl z-10 text-text-disabled t-body-xs">
          ©Carvana, LLC stock image
        </div>
      )}
    </div>
  ) : null;
}

export default memo(VehicleImage);
